<template>
    <v-container
            v-if="stack.api.getLoaded"
    >
        <h2>
            {{ stack.name }}
            <v-btn
                    v-if="canEditStacks"
                    secondary
                    @click="editStack()"
            >
                <v-icon left>mdi-pencil></v-icon> {{ $t('nav.edit') }}
            </v-btn>
        </h2>
        <v-container
                class="d-flex align-content-center"
                fluid
        >
            <stack-drill-card
                    v-if="stack.status.level0Count"
                    :title="$t('title.unmemorized')"
                    :text="$t('text.drillUnmemorized')"
                    :count="stack.status.level0Count"
                    @clicked="startQuiz(0)"
            ></stack-drill-card>
            <stack-drill-card
                    v-if="stack.status.level1Count"
                    :title="$t('title.shortTerm')"
                    :text="$t('text.drillShortTerm')"
                    :count="stack.status.level1Count"
                    @clicked="startQuiz(1)"
            ></stack-drill-card>
            <stack-drill-card
                    v-if="stack.status.level2Count"
                    :title="$t('title.longTerm')"
                    :text="$t('text.drillLongTerm')"
                    :count="stack.status.level2Count"
                    @clicked="startQuiz(2)"
            ></stack-drill-card>
            <stack-drill-card
                    v-if="stack.cardCount"
                    :title="$t('title.allCards')"
                    :text="$t('text.drillDeck')"
                    :count="stack.cardCount"
                    @clicked="startQuiz(-1)"
            ></stack-drill-card>
        </v-container>
        <v-container>
            <v-btn
                    class="ms-3"
                    @click="returnToCardset()"
            >{{ $t('nav.returnToCardset') }}</v-btn>
            <v-btn
                    @click="gotoCardList()"
                    :class="classButtonRight"
            >{{ $t('nav.gotoCardList') }}</v-btn>
        </v-container>
    </v-container>
</template>

<script>
    import basic from "@/components/mixins/basic";
    import StackMixin from "@/components/mixins/StackMixin";
    import {Stack} from "@/models/Stack";
    import StackDrillCard from "@/components/StackDrillCard";

    export default {
        name: "StackDrillChoice",
        components: {StackDrillCard},
        mixins: [basic, StackMixin],
        props: {
            pk: {
                required: true,
                type: Number,
            },
            cardsetId: {
                required: true,
                type: Number,
            }
        },
        data: function () {
            return {
                stack: new Stack(),
                dialog: false,
            }
        },
        methods: {
            editStack() {
                this.dialog = true;
            },
            setBreadCrumbs() {
                this.$store.dispatch('resetBreadCrumbs');
                this.$store.commit('pushBreadCrumb', {
                    text: this.cardset.name,
                    to: {
                        name: 'cardset-detail',
                        params: {
                            pk: this.cardsetId,
                        }
                    },
                    enabled: true,
                });
                this.$store.commit('pushBreadCrumb', {
                    text: this.stack.name,
                    to: {
                        name: 'stack-drill',
                        params: {
                            pk: this.pk,
                            cardsetId: this.cardsetId,
                        }
                    },
                    enabled: true,
                });

            }
        },
        computed: {},
        mounted() {
            let that = this;
            this.stack.api.fetch(this.pk).then(function () {
                that.fetchCardset(that.cardsetId).then(function () {
                    that.setBreadCrumbs();
                });
            });
        }
    }
</script>

<style scoped>

</style>